import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';

export const CompareFilterMultiselectCont = styled.div`
  position: relative;
  z-index: 500;
`;

export const BodyHeader = styled.div`
  display: flex;
  align-items: center;
  height: 31px;
  box-sizing: border-box;
  ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.primary[10]};
      padding: 0 16px;
   `}
`;

export const SearchCont = styled.div`
  position: relative;
  ${({ theme }: IThemeProvider) => `
      border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
   `}
`;

export const TileListCont = styled.div`
  overflow: auto;
  max-height: 192px;
  text-transform: capitalize;

  ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[0]};
      border-bottom: 1px solid ${theme.colors.neutral.primary[30]};

      /* width */
       ::-webkit-scrollbar {
        width: 8px;
      }
    
      /* Track */
      ::-webkit-scrollbar-track {
        background: ${theme.colors.secondary[30]};
      }
    
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${theme.colors.secondary[70]};
        border-radius: 5px;
      }
    
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${theme.colors.secondary[100]};
      }
   `}
`;
